import React from 'react'
import imgC from './img/facebook 1.png';
import imgD from './img/instagram 1.png';


function Footer_m(){
    return(
        <div className="container-fluid p-0">
            <div className="m_footer">
                <div className="footup">
                    <div className="container">
                        <div className="mf_up row p-0">
                            <span className="col">이용약관</span>
                            <span className="col">개인정보취급방침</span>
                            <span className="col">전자상거래약관</span>
                            <span className="col">마케팅 수신동의</span>
                        </div>   
                    </div>
                </div>    
                <div className="footdown">
                    <div className="container focon1">
                        <div className="downA">
                            <div className="down-1">
                                <span className="d-title">에스씨엘앤에스 주식회사</span><br></br>
                                <span className="d-t"> 대표자 : 전승문 <br/> 사업자번호 : 150-86-01894</span><br></br>
                                <span className="d-t">주소 : 경기도 용인시 수지구 샘말로 29(고기동)</span><br></br>
                                <span className="d-t">은행 : 국민 649701-01-296949 에스씨엘앤에스 주식회사</span>
                            </div>
                            <div className="down-2">
                                <select className="select custom-select2" onChange={(e) => window.open(e.target.value)}>
                                    <option value="">패밀리사이트</option>
                                    <option value="http://www.echelon-coating.co.kr">에슐론유리막</option>
                                    <option value="http://www.sun-gard.kr">썬가드썬팅</option>
                                    <option value="http://www.madico.co.kr">마디코썬팅</option>
                                    <option value="http://www.scglobal.kr">에스씨글로벌</option>
                                    <option value="https://www.mymall.co.kr">마이몰</option>
                                </select>
                            </div>
                        </div>            
                        <div className="downB">
                            <div className="down-3">
                                <span className="d-title">ABOUT US</span><br></br>
                                <span className="d-t"> T. 1544-2160</span><br></br>
                                <span className="d-t">F. 031-263-2603</span><br></br>
                                <span className="d-t">E. 1xymam@scglobal.kr</span><br></br>
                            </div>
                            <div className="down-2">
                                <div><img className="face-icon" src={ imgC}/><img className="face-icon" src={ imgD}/></div>
                            </div>
                            <div className="m_down-3">
                                COPYRIGHTⓒ2021 ALL RIGHTS RESERVED (주)ABYS
                            </div>
                        </div>


                    </div>
                </div>                
            </div>
        </div>
    );
}



export default Footer_m;